/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GebaeudeEgidRequest } from '../model/gebaeudeEgidRequest';
// @ts-ignore
import { GebaeudeEgidRequestMeta } from '../model/gebaeudeEgidRequestMeta';
// @ts-ignore
import { GebaeudeMasterDetailEntryMeta } from '../model/gebaeudeMasterDetailEntryMeta';
// @ts-ignore
import { GebaeudeSearchResponse } from '../model/gebaeudeSearchResponse';
// @ts-ignore
import { GebaeudeStandardRequest } from '../model/gebaeudeStandardRequest';
// @ts-ignore
import { GebaeudeStandardRequestMeta } from '../model/gebaeudeStandardRequestMeta';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AvgebaeudeService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param historisiert 
     * @param egid 
     * @param kantgid 
     * @param timestamp 
     * @param timepointId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGebaeudeByFachId(historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', egid?: number, kantgid?: number, timestamp?: string, timepointId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeMasterDetailEntryMeta>;
    public loadGebaeudeByFachId(historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', egid?: number, kantgid?: number, timestamp?: string, timepointId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeByFachId(historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', egid?: number, kantgid?: number, timestamp?: string, timepointId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeByFachId(historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', egid?: number, kantgid?: number, timestamp?: string, timepointId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadGebaeudeByFachId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (egid !== undefined && egid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>egid, 'egid');
        }
        if (kantgid !== undefined && kantgid !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>kantgid, 'kantgid');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (timepointId !== undefined && timepointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>historisiert, 'historisiert');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude`;
        return this.httpClient.request<GebaeudeMasterDetailEntryMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param masterId 
     * @param historisiert 
     * @param versionId 
     * @param timestamp 
     * @param timepointId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGebaeudeById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', versionId?: string, timestamp?: string, timepointId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeMasterDetailEntryMeta>;
    public loadGebaeudeById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', versionId?: string, timestamp?: string, timepointId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', versionId?: string, timestamp?: string, timepointId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeById(masterId: string, historisiert: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', versionId?: string, timestamp?: string, timepointId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (masterId === null || masterId === undefined) {
            throw new Error('Required parameter masterId was null or undefined when calling loadGebaeudeById.');
        }
        if (historisiert === null || historisiert === undefined) {
            throw new Error('Required parameter historisiert was null or undefined when calling loadGebaeudeById.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (versionId !== undefined && versionId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>versionId, 'versionId');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (timepointId !== undefined && timepointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>historisiert, 'historisiert');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/${this.configuration.encodeParam({name: "masterId", value: masterId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<GebaeudeMasterDetailEntryMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckId 
     * @param timestamp 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGebaeudeSichtGbMeldung(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeSichtGbMeldung(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GebaeudeMasterDetailEntryMeta>>>;
    public loadGebaeudeSichtGbMeldung(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GebaeudeMasterDetailEntryMeta>>>;
    public loadGebaeudeSichtGbMeldung(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (grundstueckId === null || grundstueckId === undefined) {
            throw new Error('Required parameter grundstueckId was null or undefined when calling loadGebaeudeSichtGbMeldung.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckId !== undefined && grundstueckId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>grundstueckId, 'grundstueckId');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (timepointId !== undefined && timepointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>historisiert, 'historisiert');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/sicht/gbmeldung`;
        return this.httpClient.request<Array<GebaeudeMasterDetailEntryMeta>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param grundstueckId 
     * @param timestamp 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadGebaeudeSichtGrundstueck(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GebaeudeMasterDetailEntryMeta>>;
    public loadGebaeudeSichtGrundstueck(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GebaeudeMasterDetailEntryMeta>>>;
    public loadGebaeudeSichtGrundstueck(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GebaeudeMasterDetailEntryMeta>>>;
    public loadGebaeudeSichtGrundstueck(grundstueckId: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (grundstueckId === null || grundstueckId === undefined) {
            throw new Error('Required parameter grundstueckId was null or undefined when calling loadGebaeudeSichtGrundstueck.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckId !== undefined && grundstueckId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>grundstueckId, 'grundstueckId');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (timepointId !== undefined && timepointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>historisiert, 'historisiert');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/sicht`;
        return this.httpClient.request<Array<GebaeudeMasterDetailEntryMeta>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gebaeudeEgidRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGebaeudeEgid(gebaeudeEgidRequest: GebaeudeEgidRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeSearchResponse>;
    public searchGebaeudeEgid(gebaeudeEgidRequest: GebaeudeEgidRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeSearchResponse>>;
    public searchGebaeudeEgid(gebaeudeEgidRequest: GebaeudeEgidRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeSearchResponse>>;
    public searchGebaeudeEgid(gebaeudeEgidRequest: GebaeudeEgidRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gebaeudeEgidRequest === null || gebaeudeEgidRequest === undefined) {
            throw new Error('Required parameter gebaeudeEgidRequest was null or undefined when calling searchGebaeudeEgid.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/searchEgid`;
        return this.httpClient.request<GebaeudeSearchResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: gebaeudeEgidRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGebaeudeEgidTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeEgidRequestMeta>;
    public searchGebaeudeEgidTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeEgidRequestMeta>>;
    public searchGebaeudeEgidTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeEgidRequestMeta>>;
    public searchGebaeudeEgidTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/searchEgidTemplate`;
        return this.httpClient.request<GebaeudeEgidRequestMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gebaeudeStandardRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGebaeudeStandard(gebaeudeStandardRequest: GebaeudeStandardRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeSearchResponse>;
    public searchGebaeudeStandard(gebaeudeStandardRequest: GebaeudeStandardRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeSearchResponse>>;
    public searchGebaeudeStandard(gebaeudeStandardRequest: GebaeudeStandardRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeSearchResponse>>;
    public searchGebaeudeStandard(gebaeudeStandardRequest: GebaeudeStandardRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gebaeudeStandardRequest === null || gebaeudeStandardRequest === undefined) {
            throw new Error('Required parameter gebaeudeStandardRequest was null or undefined when calling searchGebaeudeStandard.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/search`;
        return this.httpClient.request<GebaeudeSearchResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: gebaeudeStandardRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGebaeudeStandardTemplate(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GebaeudeStandardRequestMeta>;
    public searchGebaeudeStandardTemplate(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GebaeudeStandardRequestMeta>>;
    public searchGebaeudeStandardTemplate(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GebaeudeStandardRequestMeta>>;
    public searchGebaeudeStandardTemplate(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/av/gebaeude/searchStandardTemplate`;
        return this.httpClient.request<GebaeudeStandardRequestMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
